module.exports = __webpack_public_path__ + "img/award_badge.e465e9d6.svg";